import { gql } from '@apollo/client';
export const getPlansQuery = gql `
  query GetFreePlansByMarket($marketCode: String!) {
    plans(where: { type: { _eq: free }, market_code: { _eq: $marketCode } }) {
      id
      type
    }
  }
`;
